import type { Category, MomentView } from './types'

// 此檔為前端 server API 無法連線時的 fallback demo 內容
// 真實營運時由 /api/moments 取代

export const CATEGORIES: Category[] = [
  { id: 'c-ost', slug: 'ost', name: 'OST', description: '把畫面記住的那條旋律', color: '#4A6B5A', sortOrder: 2 },
  { id: 'c-variety', slug: 'variety', name: '綜藝', description: '節目裡他最鬆的樣子 — 但只要開唱一切都真', color: '#D97757', sortOrder: 3 },
  { id: 'c-positive', slug: 'positive', name: '單曲', description: '一首一首攤開來 — 錄音室裡他最完整的樣子', color: '#C2A66B', sortOrder: 4 },
  { id: 'c-concert', slug: 'concert', name: '演唱會感動版', description: '現場的那一秒，錄音室給不了', color: '#8E3A59', sortOrder: 5 },
  { id: 'c-musical', slug: 'musical', name: '音樂劇', description: '舞台上的他，用角色唱完一整段人生', color: '#8B5E3C', sortOrder: 6 },
  { id: 'c-tenor', slug: 'tenor', name: '男高音', description: '跨越流行的聲樂質地', color: '#2A4A6B', sortOrder: 7 },
  { id: 'c-talk', slug: 'talk', name: '重要談話', description: '他說話的時候也值得好好聽', color: '#3E3E3E', sortOrder: 8 }
]

// API 通時不會用到；保留兩筆作為展示用
export const MOMENTS: MomentView[] = []
